export default __webpack_public_path__ + "static/7-0467d79b43c9750508e47767096e74b7.jpg";